import * as api from "../api";
import makeListingMixin from "./vuexListingMixin";

export default makeListingMixin(
	"dashboard",
	api.dashboards
)({
	state: {
		super: {
			layout: {
				rows: [
					[
						{
							spacing: 4,
							title: "Freshness report",
							source: "/spreadsheet/freshness",
							type: "downloadable",
							content: "Sed posuere consectetur est at lobortis"
						}
					]
				]
			}
		},
		dashboard: null
	},
	mutations: {
		loginDashboardSuccess(state, { LayoutJSON }) {
			state.dashboard = LayoutJSON;
		}
	},
	getters: {
		superDashboard: state => state.super.layout,
		dashboardLayout: state => state.dashboard
	}
}); // eslint-disable-line
